import React from 'react';
import { Calendar, Clock, Building2, Video, Plus, Search, Filter, ChevronDown, List, CalendarDays, Eye, Edit, Trash2, AlertCircle, CheckCircle, Loader, X, ChevronLeft, ChevronRight, Users, TrendingUp, FileText, Briefcase, Target, MessageSquare, Brain, Zap } from 'lucide-react';

const PracticeModal = ({ 
suggestPracticeTimes,
setNewInterview,
newInterview,
setShowPracticeModal,
setShowScheduleModal,
createInterview
}) => {


return (
<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 backdrop-blur-md ">
<div className="bg-white rounded-lg max-w-2xl w-full">
<div className="p-6 border-b border-gray-200">
<h2 className="text-2xl font-bold text-gray-900 mb-2">Schedule Practice Session</h2>
<p className="text-gray-600">
We recommend practicing before your interview. Select a time that works for you:
</p>
</div>

<div className="p-6 space-y-4">
{suggestPracticeTimes().map((suggestion, index) => (
<button
key={index}
onClick={() => {
setNewInterview({
...newInterview,
practiceDate: suggestion.date,
practiceTime: suggestion.time
});
}}
className={`w-full p-4 border-2 rounded-lg text-left transition-all ${
newInterview.practiceDate === suggestion.date && newInterview.practiceTime === suggestion.time
? 'border-purple-600 bg-purple-50'
: 'border-gray-300 hover:border-gray-400'
}`}
>
<div className="flex items-center justify-between">
<div>
<div className="font-semibold text-gray-900">{suggestion.label}</div>
<div className="text-sm text-gray-600 mt-1">
{new Date(suggestion.date).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })} at {suggestion.time}
</div>
</div>
{newInterview.practiceDate === suggestion.date && newInterview.practiceTime === suggestion.time && (
<CheckCircle className="w-6 h-6 text-purple-600" />
)}
</div>
</button>
))}

<div className="text-center text-sm text-gray-600">or</div>

<button
onClick={() => {
setNewInterview({ ...newInterview, practiceDate: '', practiceTime: '' });
}}
className={`w-full p-4 border-2 rounded-lg text-left transition-all ${
!newInterview.practiceDate && !newInterview.practiceTime
? 'border-gray-600 bg-gray-50'
: 'border-gray-300 hover:border-gray-400'
}`}
>
<div className="font-semibold text-gray-900">Skip practice session</div>
<div className="text-sm text-gray-600 mt-1">I'll prepare on my own</div>
</button>
</div>

<div className="p-6 border-t border-gray-200 flex gap-3">
<button
onClick={() => {
setShowPracticeModal(false);
setShowScheduleModal(true);
}}
className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
>
Back
</button>
<button
onClick={createInterview}
className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
>
Schedule Interview
</button>
</div>
</div>
</div>
);
};

export default PracticeModal;